import { render } from "./FullServiceBlock.vue?vue&type=template&id=1d75912e&scoped=true"
import script from "./FullServiceBlock.vue?vue&type=script&lang=js"
export * from "./FullServiceBlock.vue?vue&type=script&lang=js"

import "./FullServiceBlock.vue?vue&type=style&index=0&id=1d75912e&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d75912e"]])

export default __exports__